// extracted by mini-css-extract-plugin
module.exports = {"wrpr":"GoogleRating_wrpr__A_kot","darkMode":"GoogleRating_darkMode__HuGjf","shortLogo":"GoogleRating_shortLogo__G91z_","details":"GoogleRating_details__CL085"};